export const projectThree = {
  id: 'Project',
  lightBg: true,
  lightText: true,
  lightTextDesc: true,
  topLine: 'Project 3',
  headline: 'Pacer',
  description:
    "Allow Users to log in, and explore the many different Pacer Applications to use from spanning from start transactions, shipping, description builder, verify ID, to live Auction Browser",
  buttonLabel: 'Visit site',
  siteUrl: 'https://pacer.co/',
  imgStart: true,
  img: require('../../images/Pacer-app.mp4'),
  alt: 'Pacer',
  dark: true,
  primary: true,
  darkText: false
};
